import React, { Component } from 'react'
import SideMenu from '../admin/SideMenu';
import TopMenu from '../admin/TopBar';
import UploadImage from '../utils/UploadImage';
import { base } from '../../base';
import '../../styles/css/AdminMain.css';
import swal from 'sweetalert2';
import { Modal } from 'reactstrap';
import { PhotoshopPicker } from 'react-color';
import RichTextMarkdown from "../utils/RichTextMarkdown";
import {isEmptyHtmlEntity} from "../utils/HelpfulFunction";

class SetUpTeamVariables extends Component {
    constructor(props) {
        super(props);
        this.UploadImage = new UploadImage();
        this.state = {
            tenantVariables: {},
            showTabOne: true,
            showTabTwo: false,
            showTabThree: false,
            loading:true,
            colorToShow: "#ffffff",
            colorToUpdate: "",
            colorPickerShow: false,
            colorsTab: true
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
    }

    componentDidMount() {
      this.tenantVariablesRef = base.bindToState(`tenantVariables`, {
        context: this,
        state: 'tenantVariables',
      });
      this.setState({
        loading: false
      })
    }

    componentWillUnmount() {
      base.removeBinding(this.tenantVariablesRef);
    }

    handleSubmit(event) {
      event.preventDefault();
        const variables = this.state.tenantVariables;
        let afterFinishPredictingBody = variables['afterFinishPredictingBody'];
        if(isEmptyHtmlEntity(afterFinishPredictingBody)){
            afterFinishPredictingBody = "";
        }
        variables['afterFinishPredictingBody'] = afterFinishPredictingBody;
      let vm = this;
      base.post("tenantVariables/", {
        data: variables,
        then(err){
          vm.setState({loading:false})
          if(!err){
            swal({
                title: 'Tenant Variables Updated!',
                type: 'success',
                toast: true,
                position: 'top-end',
                showConfirmButton: true,
                timer: 10000
              })
          } else {
            swal({
                title: 'There was some error!',
                text: 'Try again and if the problem persists try logging out and logging back in',
                type: 'error',
                confirmButtonText: 'Ok'
              })
            console.log(err)
          }
        }
      })
    }

    handleChange (evt) {
      let tenantVariablesCopy = this.state.tenantVariables;
      tenantVariablesCopy[evt.target.name] = evt.target.value
      this.setState({ tenantVariables:  tenantVariablesCopy});
    }

    handleImageChange(event){
      let name_of_file = event.target.name;
      let target = this[name_of_file];
      let file_to_update =target.files[0];
      this.setState({loading:true})
      let vm = this;
      this.UploadImage.upload_file(file_to_update).then(res => {
          vm.setState({loading:false})
          if(res.error){
              swal({
                  title: 'Image cannot be uploaded',
                  text: res.error,
                  type: 'warning',
                  confirmButtonText: 'Ok'
              })
          } else if(res.imageUrl) {
              let tenantVariablesCopy = vm.state.tenantVariables;
              tenantVariablesCopy[name_of_file] = res.imageUrl
              vm.setState({
                  tenantVariables: tenantVariablesCopy,
              }, () => {
                  vm[name_of_file].value = ""
              });
          } else {
              swal({
                  title: 'Image cannot be uploaded',
                  text: "Something went wrong, please re-upload your image and try again!",
                  type: 'warning',
                  confirmButtonText: 'Ok'
              })
          }
      })
    }

    switchTextShowing(element){
      if(element === "first"){
        document.getElementById('showfirst').classList.add('active');
        document.getElementById('showthird').classList.remove('active');
        this.setState({
          showTabOne: true,
          showTabTwo: false,
          showTabThree: false,
        })
      }else if(element === "second"){
        document.getElementById('showfirst').classList.remove('active');
        document.getElementById('showthird').classList.remove('active');
        this.setState({
          showTabOne: false,
          showTabTwo: true,
          showTabThree: false,
        })
      } else {
        document.getElementById('showfirst').classList.remove('active');
        document.getElementById('showthird').classList.add('active');
        this.setState({
          showTabOne: false,
          showTabTwo: false,
          showTabThree: true,
        })
      }
    }

    openColorPicker(colorToChange){
        let oldColor = this.state.tenantVariables[colorToChange] || '#fff';
        this.setState({
            colorPickerShow: true,
            colorToShow: oldColor,
            colorToUpdate: colorToChange
        })
    }

    handleChangeComplete = (color) => {
        this.setState({
            colorToShow: color.hex
        })
    };

    acceptPicker(){
        let colorToChange = this.state.colorToUpdate;
        let tenantVariables = this.state.tenantVariables;
        tenantVariables[colorToChange] = this.state.colorToShow;
        this.setState({
            tenantVariables: tenantVariables,
            updateHappend: true,
            colorPickerShow: false,
        })
    }

    dismissPicker(){
        this.setState({
            colorPickerShow: false,
        })
    }

    toggleColors(){
        if(this.state.colorsTab){
            document.getElementById('showColors').classList.remove('active');
            document.getElementById('showImages').classList.add('active');
        } else {
            document.getElementById('showColors').classList.add('active');
            document.getElementById('showImages').classList.remove('active');
        }
        this.setState({colorsTab: !this.state.colorsTab})
    }

    handleRichTextChange = (name, text) => {
        let tenantVariablesCopy = this.state.tenantVariables;
        tenantVariablesCopy[name] = text;
        this.setState({ tenantVariables:  tenantVariablesCopy});
    }

    render() {
        const { tenantVariables } = this.state;
        let backgroundImage = tenantVariables.backgroundImage;
        let frontImage = tenantVariables.frontLogoImage;
        let teamLogo = tenantVariables.topLeftImage;
        return (
          <div className="admin-wrapper">
            <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
            <SideMenu/>
            <TopMenu/>
            <div className="admin-main-panel">
                <p className="admin-header-text" style={{marginBottom:0, marginTop:'5px'}}>Game Branding</p>
                <p className="admin-subheader-text">This is where you can edit the game branding on your activation</p>
                <div className="container-out">
                  <div className="admin-form-box" style={{marginTop:'0px', paddingTop:'5px'}}>
                    <form onSubmit={this.handleSubmit} id="create-game-form">
                      <button className="btn btn-primary btn-lg update-button" id="submitButton" style={{marginBottom:'20px'}}><span className="fa fa-arrow-circle-o-up"/> Update</button>
                      <ul className="nav nav-tabs nav-justified nav-bordered mb-3">
                          <li className="nav-item" onClick={()=> this.switchTextShowing('first')}>
                              <a href="#" data-toggle="tab" aria-expanded="false" className="nav-link active" id="showfirst">
                                  <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                  <span className="d-none d-lg-block">Fan Color/Images</span>
                              </a>
                          </li>
                          <li className="nav-item" onClick={()=> this.switchTextShowing('third')}>
                              <a href="#" data-toggle="tab" aria-expanded="true" className="nav-link" id="showthird">
                                  <i className="mdi mdi-account-circle d-lg-none d-block mr-1"/>
                                  <span className="d-none d-lg-block">Game Text</span>
                              </a>
                          </li>
                      </ul>
                    <ul className="nav nav-tabs nav-justified nav-bordered mb-3" style={{display: this.state.showTabOne === true ? '' : 'none'}}>
                        <li className="nav-item" onClick={()=> this.toggleColors()}>
                            <a href="#" data-toggle="tab" aria-expanded="false" className="nav-link active" id="showColors">
                                <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                <span className="d-none d-lg-block">Colors</span>
                            </a>
                        </li>
                        <li className="nav-item" onClick={()=> this.toggleColors()}>
                            <a href="#" data-toggle="tab" aria-expanded="true" className="nav-link" id="showImages">
                                <i className="mdi mdi-home-variant d-lg-none d-block mr-1"/>
                                <span className="d-none d-lg-block">Images</span>
                            </a>
                        </li>
                    </ul>
                      <div style={{display: this.state.showTabOne ? 'block' : 'none'}}>
                          <div style={{display: this.state.colorsTab ? 'block': 'none'}}>
                            <div className="row">
                                <div className="col-md-6">
                                    <h4>Primary Button Colors</h4>
                                    <div className="form-inline">
                                        <span style={{marginRight:10}} className="fa fa-eyedropper mobile-hide" onClick={()=> this.openColorPicker("primaryColor")}/>
                                        <div style={{backgroundColor: this.state.tenantVariables.primaryColor, marginRight: 10, border: "solid 1px", minHeight: 20, width: 20, display: "inline-block"}}/>
                                        <label htmlFor="primaryColor" style={{marginRight: 10}}>Background Color</label>
                                        <input id="primaryColor" name="primaryColor" type="text" className="form-control" value={this.state.tenantVariables.primaryColor} onChange={this.handleChange} placeholder="#000" style={{marginRight:10}}/>

                                        <div style={{height:'10px', width:'100%'}}/>

                                        <span style={{marginRight:10}} className="fa fa-eyedropper mobile-hide" onClick={()=> this.openColorPicker("secondaryColor")}/>
                                        <div style={{backgroundColor: this.state.tenantVariables.secondaryColor, marginRight: 10, border: "solid 1px", minHeight: 20, width: 20, display: "inline-block"}}/>
                                        <label htmlFor="secondaryColor" style={{marginRight: 10}}>Text Color</label>
                                        <input id="secondaryColor" name="secondaryColor" type="text" className="form-control" value={this.state.tenantVariables.secondaryColor} onChange={this.handleChange} placeholder="#000"/>

                                        <div style={{height:'10px', width:'100%'}}/>

                                        <span style={{marginRight:10}} className="fa fa-eyedropper mobile-hide" onClick={()=> this.openColorPicker("buttonOutlineColor")}/>
                                        <div style={{backgroundColor: this.state.tenantVariables.buttonOutlineColor, marginRight: 10, border: "solid 1px", minHeight: 20, width: 20, display: "inline-block"}}/>
                                        <label htmlFor="buttonOutlineColor" style={{marginRight: 10}}>Outline Color</label>
                                        <input id="buttonOutlineColor" name="buttonOutlineColor" type="text" className="form-control" value={this.state.tenantVariables.buttonOutlineColor} onChange={this.handleChange} placeholder="#000" style={{marginRight:10}}/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <h4>Log Out Colors</h4>
                                    <div className="form-inline">
                                        <span style={{marginRight:10}} className="fa fa-eyedropper mobile-hide" onClick={()=> this.openColorPicker("logOutButtonColor")}/>
                                        <div style={{backgroundColor: this.state.tenantVariables.logOutButtonColor, marginRight: 10, border: "solid 1px", minHeight: 20, width: 20, display: "inline-block"}}/>
                                        <label htmlFor="logOutButtonColor" style={{marginRight: 10}}>Log Out Button Color</label>
                                        <input id="logOutButtonColor" name="logOutButtonColor" type="text" className="form-control" value={this.state.tenantVariables.logOutButtonColor} onChange={this.handleChange} placeholder="#000" style={{marginRight:10}}/>
                                    </div>
                                </div>
                            </div>

                              <div style={{height:'10px', width:'100%'}}/>

                              <div className="row">
                                  <div className="col-md-6">
                                      <h4>Other Colors</h4>
                                      <div className="form-inline">
                                          <span style={{marginRight:10}} className="fa fa-eyedropper mobile-hide" onClick={()=> this.openColorPicker("sliderColor")}/>
                                          <div style={{backgroundColor: this.state.tenantVariables.sliderColor, marginRight: 10, border: "solid 1px", minHeight: 20, width: 20, display: "inline-block"}}/>
                                          <label htmlFor="sliderColor" style={{marginRight: 10}}>Slider Color</label>
                                          <input id="sliderColor" name="sliderColor" type="text" className="form-control" value={this.state.tenantVariables.sliderColor} onChange={this.handleChange} placeholder="#000" style={{marginRight:10}}/>

                                          <div style={{height:'10px', width:'100%'}}/>

                                          <span style={{marginRight:10}} className="fa fa-eyedropper mobile-hide" onClick={()=> this.openColorPicker("questionColor")}/>
                                          <div style={{backgroundColor: this.state.tenantVariables.questionColor, marginRight: 10, border: "solid 1px", minHeight: 20, width: 20, display: "inline-block"}}/>
                                          <label htmlFor="questionColor" style={{marginRight: 10}}>Question Color</label>
                                          <input id="questionColor" name="questionColor" type="text" className="form-control" value={this.state.tenantVariables.questionColor} onChange={this.handleChange} placeholder="#000" style={{marginRight:10}}/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div style={{display: this.state.colorsTab ? 'none' : 'block'}}>
                        <div className="admin-grid-container three-columns" style={{float:'left', display: 'flex', alignItems: 'flex-end'}}>
                          <div className="form-group" style={{textAlign:'center', margin:20}}>
                            <img src={backgroundImage} width="160" height="auto" alt=""/>
                            <br/>
                            <label htmlFor="backgroundImage">Phone Background Image<br/></label>
                            <div className="form-group">
                              <input style={{display:'none'}} id="backgroundImage" name="backgroundImage" type="file" ref={input => {this.backgroundImage = input; }} onChange={this.handleImageChange}/>
                              <input className='btn btn-primary btn-lg choose-image-button' type="button" value="Choose Image" onClick={() => document.getElementById('backgroundImage').click()} />
                            </div>
                          </div>
                          <div className="form-group" style={{textAlign:'center', margin:20}}>
                            <img src={frontImage} width="150" height="auto" alt=""/>
                            <br/>
                            <label htmlFor="frontLogoImage">Front Logo<br/></label>
                            <div className="form-group">
                              <input style={{display:'none'}} id="frontLogoImage" name="frontLogoImage" type="file" ref={input => {this.frontLogoImage = input; }} onChange={this.handleImageChange}/>
                              <input className='btn btn-primary btn-lg choose-image-button' type="button" value="Choose Image" onClick={() => document.getElementById('frontLogoImage').click()} />
                            </div>
                          </div>
                        </div>
                        <div className="admin-grid-container three-columns" style={{float:'left', display: 'flex', alignItems: 'flex-end'}}>
                          <div className="form-group" style={{float:'left', textAlign:'center', margin:20}}>
                            <img src={teamLogo} width="100" height="auto" alt=""/>
                            <br/>
                            <label htmlFor="topLeftImage">Top Logo<br/></label>
                            <div className="form-group">
                              <input style={{display:'none'}} id="topLeftImage" name="topLeftImage" type="file" ref={input => {this.topLeftImage = input; }} onChange={this.handleImageChange}/>
                              <input className='btn btn-primary btn-lg choose-image-button' type="button" value="Choose Image" onClick={() => document.getElementById('topLeftImage').click()} />
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                      <div style={{display: this.state.showTabThree ? 'block' : 'none'}}>
                          <div className="form-group">
                              <label htmlFor="pageTitle">Page Title:</label>
                              <p className="text-muted" style={{fontSize:12}}>This is the text that shows up in the browser tab in your app and on the web (Ex. Team Prediction)</p>
                              <input id="pageTitle" name="pageTitle" type="text" className="form-control" value={this.state.tenantVariables.pageTitle} onChange={this.handleChange} placeholder="Prediction"/>
                          </div>
                          <hr/>
                          <div className="form-group">
                              <label htmlFor="winningMessage">Holding Screen Text:</label>
                              <p className="text-muted" style={{fontSize:12}}>This is the text that shows up on the holding page if the game is not active. It should finish the sentence: The next game starts....</p>
                              <RichTextMarkdown
                                  field={{
                                      id: "playingText",
                                      name: "playingText",
                                      value: tenantVariables.playingText || ""
                                  }}
                                  form={{
                                      setFieldValue: (field, value) => this.handleRichTextChange('playingText', value)
                                  }}
                                  placeholder="2nd Quarter"
                              />
                          </div>
                          <hr/>
                          <div className="form-group">
                              <label htmlFor="loginFormHeader">Login Form Header</label>
                              <RichTextMarkdown
                                  field={{
                                      id: "loginFormHeader",
                                      name: "loginFormHeader",
                                      value: tenantVariables.loginFormHeader || ""
                                  }}
                                  form={{
                                      setFieldValue: (field, value) => this.handleRichTextChange('loginFormHeader', value)
                                  }}
                                  placeholder=""
                              />
                          </div>
                          <hr/>
                          <div className="form-group">
                              <label htmlFor="aboveFormText">Above Form Text</label>
                              <RichTextMarkdown
                                  field={{
                                      id: "aboveFormText",
                                      name: "aboveFormText",
                                      value: tenantVariables.aboveFormText || ""
                                  }}
                                  form={{
                                      setFieldValue: (field, value) => this.handleRichTextChange('aboveFormText', value)
                                  }}
                                  placeholder="Enter text above the form"
                              />
                          </div>
                          <hr/>
                          <div className="form-group">
                              <label htmlFor="aboveSubmitButtonText">Above Submit Button Text Login Page</label>
                              <RichTextMarkdown
                                  field={{
                                      id: "aboveSubmitButtonText",
                                      name: "aboveSubmitButtonText",
                                      value: tenantVariables.aboveSubmitButtonText || ""
                                  }}
                                  form={{
                                      setFieldValue: (field, value) => this.handleRichTextChange('aboveSubmitButtonText', value)
                                  }}
                                  placeholder="Enter text above the submit button on the login screen"
                              />
                          </div>
                          <hr/>
                          <div className="form-group">
                              <label htmlFor="belowSubmitButtonText">Below Submit Button Text Login Page</label>
                              <RichTextMarkdown
                                  field={{
                                      id: "belowSubmitButtonText",
                                      name: "belowSubmitButtonText",
                                      value: tenantVariables.belowSubmitButtonText || ""
                                  }}
                                  form={{
                                      setFieldValue: (field, value) => this.handleRichTextChange('belowSubmitButtonText', value)
                                  }}
                                  placeholder="Enter text below the submit button on the login screen"
                              />
                          </div>
                        <hr/>
                        <div className="form-group">
                          <label htmlFor="belowCorrectText">Below Incorrect/Correct Text:</label>
                          <p className="text-muted" style={{fontSize:12}}>This is the text that shows up below highlighted correct/incorrect text after the question has been entered.</p>
                          <input id="belowCorrectText" name="belowCorrectText" type="text" className="form-control" value={this.state.tenantVariables.belowCorrectText} onChange={this.handleChange} placeholder="THE GAME HAS ENDED. COME BACK NEXT GAME!"/>
                        </div>
                        <hr/>
                          <div className="form-group">
                              <label htmlFor="winningHeader">Winning Header</label>
                              <input id="winningHeader" name="winningHeader" type="text" className="form-control" value={this.state.tenantVariables.winningHeader} onChange={this.handleChange} placeholder="You Win!"/>
                          </div>

                          <div className="form-group">
                              <label htmlFor="winningMessage">Winning Message</label>
                              <RichTextMarkdown
                                  field={{
                                      id: "winningMessage",
                                      name: "winningMessage",
                                      value: tenantVariables.winningMessage || ""
                                  }}
                                  form={{
                                      setFieldValue: (field, value) => this.handleRichTextChange('winningMessage', value)
                                  }}
                                  placeholder="Congratulations"
                              />
                          </div>

                          <div className="form-group">
                              <label htmlFor="winningNoPrizeHeader">Winning Header No Prize</label>
                              <input id="winningNoPrizeHeader" name="winningNoPrizeHeader" type="text" className="form-control" value={this.state.tenantVariables.winningNoPrizeHeader} onChange={this.handleChange} placeholder="You Win!"/>
                          </div>

                          <div className="form-group">
                              <label htmlFor="playingText">Winning Message No Prize</label>
                              <RichTextMarkdown
                                  field={{
                                      id: "winningNoPrizeMessage",
                                      name: "winningNoPrizeMessage",
                                      value: tenantVariables.winningNoPrizeMessage || ""
                                  }}
                                  form={{
                                      setFieldValue: (field, value) => this.handleRichTextChange('winningNoPrizeMessage', value)
                                  }}
                                  placeholder="Unfortunately all prizes have been given out"
                              />
                          </div>

                          <div className="form-group">
                              <label htmlFor="losingHeaderPrize">Losing Header Prize</label>
                              <input id="losingHeaderPrize" name="losingHeaderPrize" type="text" className="form-control" value={this.state.tenantVariables.losingHeaderPrize} onChange={this.handleChange} placeholder="You Lose!"/>
                          </div>

                          <div className="form-group">
                              <label htmlFor="losingMessagePrize">Losing Message Prize</label>
                              <RichTextMarkdown
                                  field={{
                                      id: "losingMessagePrize",
                                      name: "losingMessagePrize",
                                      value: tenantVariables.losingMessagePrize || ""
                                  }}
                                  form={{
                                      setFieldValue: (field, value) => this.handleRichTextChange('losingMessagePrize', value)
                                  }}
                                  placeholder="But you still get a prize!"
                              />
                          </div>

                          <div className="form-group">
                              <label htmlFor="losingHeader">Losing Header No Prize</label>
                              <input id="losingHeader" name="losingHeader" type="text" className="form-control" value={this.state.tenantVariables.losingHeader} onChange={this.handleChange} placeholder="You Lose!"/>
                          </div>

                          <div className="form-group">
                              <label htmlFor="losingMessage">Losing Message No Prize</label>
                              <RichTextMarkdown
                                  field={{
                                      id: "losingMessage",
                                      name: "losingMessage",
                                      value: tenantVariables.losingMessage || ""
                                  }}
                                  form={{
                                      setFieldValue: (field, value) => this.handleRichTextChange('losingMessage', value)
                                  }}
                                  placeholder="Better luck next time"
                              />
                          </div>

                          <div className="form-group">
                              <label htmlFor="alreadyHappenedHeader">Event Already Happened Header</label>
                              <input id="alreadyHappenedHeader" name="alreadyHappenedHeader" type="text" className="form-control" value={this.state.tenantVariables.alreadyHappenedHeader} onChange={this.handleChange} placeholder="Oh no!"/>
                          </div>

                          <div className="form-group">
                              <label htmlFor="alreadyHappenedMessage">Event Already Happened Message</label>
                              <RichTextMarkdown
                                  field={{
                                      id: "alreadyHappenedMessage",
                                      name: "alreadyHappenedMessage",
                                      value: tenantVariables.alreadyHappenedMessage || ""
                                  }}
                                  form={{
                                      setFieldValue: (field, value) => this.handleRichTextChange('alreadyHappenedMessage', value)
                                  }}
                                  placeholder="The contest already happened but come back next time to try again!"
                              />
                          </div>

                        <hr/>
                        <div className="form-group">
                            <label htmlFor="afterFinishPredictingHeader">After Finishing Predictions Headers:</label>
                            <input id="afterFinishPredictingHeader" name="afterFinishPredictingHeader" type="text" className="form-control" value={this.state.tenantVariables.afterFinishPredictingHeader} onChange={this.handleChange} placeholder="Nice Job!"/>
                        </div>

                          <div className="form-group">
                              <label htmlFor="afterFinishPredictingBody">After Finishing Predictions Body:</label>
                              <RichTextMarkdown
                                  field={{
                                      id: "afterFinishPredictingBody",
                                      name: "afterFinishPredictingBody",
                                      value: tenantVariables.afterFinishPredictingBody || ""
                                  }}
                                  form={{
                                      setFieldValue: (field, value) => this.handleRichTextChange('afterFinishPredictingBody', value)
                                  }}
                                  placeholder="You answered all the predictions"
                              />
                          </div>
                      </div>
                    </form>
                  </div>
                </div>
            </div>
              <Modal isOpen={this.state.colorPickerShow} toggle={this.state.colorPickerShow} id="myModal">
                  <PhotoshopPicker onChangeComplete={ this.handleChangeComplete } color={this.state.colorToShow} onAccept={()=>this.acceptPicker()} onCancel={()=> this.dismissPicker()}/>
              </Modal>
         </div>
        );
    }
}

export default SetUpTeamVariables;
